import React, { useState, useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { GetAllCompliances, DeleteCompliance } from '@services/Compliance/Index.jsx';
import FilterView from '@components/UI/FilterView/Index.jsx';
import { EditOptionComp } from '@components/UI/EditOption/Index.jsx';
import { DeleteOptionComp } from '@components/UI/DeleteOption/Index.jsx';
import ptBR from 'antd/es/locale/pt_BR';
import { StyledTable } from '@styles/datatables/datatable-antd.js';
import { Spinner } from '@styles/loading.js';
import TextBlock from '@components/UI/TextBlock/Index..jsx';
import Select from 'react-select';
import { tipoComplianceOptions } from '@enums/Compliance/Index';
import customStylesSelect from '@styles/react-select';

const GridCompliance = ({ state, setData, openModal, setSelectedRow, onDelete }) => {
  const [filters, setFilters] = useState({
    codigo: "",
    ano: "",
    tipoCompliance: "",
    servico: "",
    tipo: "",
    nomeProcesso: ""
  });
  const filterLabels = {
    codigo: "CÓDIGO",
    ano: "ANO",
    tipoCompliance: "COMPLIANCE",
    servico: "SERVIÇO",
    tipo: "TIPO",
    nomeProcesso: "PROCESSO"
  };
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Busca os dados da API
  const fetchData = async (currentPage, currentRowsPerPage, filters = {}) => {
    setLoading(true);
    try {
      const response = await GetAllCompliances(currentPage, currentRowsPerPage, filters);
      setData(response.items, response.totalItems);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  // Atualiza os dados quando a página ou o número de linhas por página muda
  useEffect(() => {
    fetchData(page, rowsPerPage, filters);
  }, [page, rowsPerPage, filters]);


  // Manipula a mudança de página
  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    if (newRowsPerPage) {
      setRowsPerPage(newRowsPerPage);
    }
  };

  // Colunas da tabela
  const columns = [
    {
      title: 'CÓDIGO',
      dataIndex: 'codigo',
      key: 'codigo',
      width: '15%',
      sorter: (a, b) => a.codigo.localeCompare(b.codigo), // Ordenação
    },
    {
      title: 'ANO',
      dataIndex: 'ano',
      key: 'ano',
      width: '10%',
      sorter: (a, b) => a.ano.localeCompare(b.ano), // Ordenação
    },
    {
      title: 'COMPLIANCE',
      key: 'tipoCompliance',
      width: '20%',
      render: (_, record) => record.tipoCompliance,
      sorter: (a, b) => a.tipoCompliance - b.tipoCompliance, // Ordenação
    },
    {
      title: 'SERVIÇO',
      dataIndex: 'tipoServico',
      key: 'tipoServico',
      width: '15%',
      sorter: (a, b) => a.tipoServico.localeCompare(b.tipoServico), // Ordenação
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'TIPO',
      dataIndex: 'tipoServicoAssociado',
      key: 'tipoServicoAssociado',
      width: '15%',
      sorter: (a, b) => a.tipoServicoAssociado.localeCompare(b.tipoServicoAssociado), // Ordenação
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'PROCESSO',
      dataIndex: 'nomeProcesso',
      key: 'nomeProcesso',
      width: '15%',
      sorter: (a, b) => a.nomeProcesso.localeCompare(b.nomeProcesso), // Ordenação
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'AÇÕES',
      key: 'actions',
      width: '10%',
      render: (_, record) => (
        <div className="d-flex justify-content-center gap-3">
          <EditOptionComp
            row={record}
            setSelectedRow={setSelectedRow}
            openModal={openModal}
          />
          <DeleteOptionComp
            row={record}
            deleteFunction={DeleteCompliance}
            onDelete={onDelete}
            itemNameKey={"codigo"}
          />
        </div>
      ),
    },
  ];

  const customFieldComponents = {
    tipoCompliance: ({ value, onChange }) => (
      <Select
        value={tipoComplianceOptions.find(opt => opt.value === value)}
        onChange={option => onChange(option?.value ?? "")}
        options={tipoComplianceOptions}
        placeholder={"Selecione um tipo de compliance"}
        isClearable
        isSearchable={false}
        styles={customStylesSelect}
      />
    ),
  };

  return (
    <div className='px-4'>

      <FilterView
        filters={filters}
        setFilters={setFilters}
        filterLabels={filterLabels}
        customFieldComponents={customFieldComponents}
      />

      <div className='mt-3 mb-3'>
        <h1>Lista de Compliances Registrados</h1>
      </div>

      <ConfigProvider locale={ptBR}>
        <StyledTable
          columns={columns}
          dataSource={state.data}
          rowKey="codigo"
          loading={{
            spinning: loading,
            indicator: <Spinner />,
          }}
          pagination={{
            current: page,
            pageSize: rowsPerPage,
            total: state.totalRows,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            onChange: handlePageChange,
            onShowSizeChange: handlePageChange,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`, // Exibe o total de registros
          }}
          scroll={{ y: '20rem' }}
          locale={{
            emptyText: <h2 className='m-3'>Nenhum registro disponível para exibição.</h2>, // Mensagem quando não há dados
          }}
        />
      </ConfigProvider>
    </div>
  );
};

export default GridCompliance;